
import { mapGetters, mapMutations } from 'vuex';
import debounce from 'debounce';
import productBundleService from './../../../../services/productBundle';
import accountService from './../../../../services/account';
import store from './../../../../store';
import SearchMixin from './../../../../mixins/search';
import stringFormatMixin from './../../../../mixins/stringFormat';

export default {
  data() {
    return {
      info: 'info',
      loading: true,
      search: '',
      limit: 25,
    };
  },

  components: {
    VCard: require('./../../../../components/card/card.vue'),
    VPagination: require('./../../../../components/paginationNew/paginationNew.vue'),
    VNoData: require('./../../../../components/noData/noData.vue'),
  },

  computed: {
    ...mapGetters({
      products: 'paginatedProducts',
      account: 'account',
      searchQuery: 'productQuery',
    }),

    hasInventory() {
      if (this.account.modules.length > 0) {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < this.account.modules.length; i++) {
          if (this.account.modules[i].name === 'Inventory') {
            return true;
          }
        }
      }
      return false;
    },
  },

  watch: {
    $route() {
      this.all(this.searchQuery.page, this.limit);
    },
  },

  methods: {
    ...mapMutations({
      setInnerSidebar: 'SET_INNERSIDEBAR',
      unsetInnerSidebar: 'UNSET_INNERSIDEBAR',
    }),

    all: debounce(function (page, limit) {
      this.loading = true;
      const query = { page, limit, search: this.searchQuery.search };
      store.dispatch('setProductQuery', query);
      this.search = this.searchQuery.search;
      productBundleService.items({
        page,
        limit,
        search: this.searchQuery.search,
      })
      .then(() => {
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    }, 800),

    onChangeSearch(name, value) {
      store.dispatch('setProductQuery', { page: 1, limit: this.limit, search: value });
      this.all(1, this.limit);
    },

    perPage(size) {
      accountService.rememberPerPage('post', { from: 'product', perPage: size })
      .then((data) => {
        this.limit = data.size;
      }).catch((error) => {
        console.log(error);
      });
    },

    sidebar() {
      let productFilter = {
        title: this.$t('static.products.filters.title'),
        options: [{
          title: this.$t('static.products.filters.withDeposit'),
          route: {
            name: 'products.index',
            query: {
              filter: 'withDeposit',
            },
          },
        },
        {
          title: this.$t('static.products.filters.active'),
          route: {
            name: 'products.index',
            query: {
              filter: 'active',
            },
          },
        },
        {
          title: this.$t('static.products.filters.deactivated'),
          route: {
            name: 'products.index',
            query: {
              filter: 'deactivated',
            },
          },
        },
        {
          title: this.$t('static.products.filters.materials'),
          route: {
            name: 'products.index',
            query: {
              type: 'Material',
            },
          },
        },
        {
          title: this.$t('static.products.filters.all'),
          route: {
            name: 'products.index',
          },
        },
        ],
        button: {
          title: `+ ${this.$t('static.products.create.title')}`,
          route: {
            name: 'products.create',
          },
        },
      };
      let vmpSyncMenu = {};
      if (this.account.modules.length > 0) {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < this.account.modules.length; i++) {
          if (this.account.modules[i].name === 'EDI') {
            productFilter = {
              title: this.$t('static.products.filters.title'),
              options: [{
                title: this.$t('static.products.filters.active'),
                route: {
                  name: 'products.index',
                  query: {
                    filter: 'active',
                  },
                },
              },
              {
                title: this.$t('static.products.filters.deactivated'),
                route: {
                  name: 'products.index',
                  query: {
                    filter: 'deactivated',
                  },
                },
              },
              {
                title: this.$t('static.products.filters.withDeposit'),
                route: {
                  name: 'products.index',
                  query: {
                    filter: 'withDeposit',
                  },
                },
              },
              {
                title: this.$t('static.products.filters.materials'),
                route: {
                  name: 'products.index',
                  query: {
                    type: 'Material',
                  },
                },
              },
              {
                title: this.$t('static.products.filters.asko'),
                route: {
                  name: 'products.index',
                  query: {
                    filter: 'asko',
                  },
                },
              },
              {
                title: this.$t('static.products.filters.vinhuset'),
                route: {
                  name: 'products.index',
                  query: {
                    filter: 'vinhuset',
                  },
                },
              },
              {
                title: this.$t('static.products.filters.marketplace'),
                route: {
                  name: 'products.index',
                  query: {
                    filter: 'marketplace',
                  },
                },
              },
              {
                title: this.$t('static.products.filters.onlineStore'),
                route: {
                  name: 'products.index',
                  query: {
                    filter: 'onlineStore',
                  },
                },
              },
              {
                title: this.$t('static.products.filters.alcohol'),
                route: {
                  name: 'products.index',
                  query: {
                    filter: 'alcohol',
                  },
                },
              },
              {
                title: this.$t('static.products.filters.alcoholFree'),
                route: {
                  name: 'products.index',
                  query: {
                    filter: 'alcoholFree',
                  },
                },
              },
              {
                title: this.$t('static.products.filters.all'),
                route: {
                  name: 'products.index',
                },
              },
              ],
              button: {
                title: `+ ${this.$t('static.products.create.title')}`,
                route: {
                  name: 'products.create',
                },
              },
            };
          }
          if (this.account.modules[i].name == 'Vinmonopolet') {
            vmpSyncMenu = {
              title: this.$t('static.products.syncVmp.title'),
              button: {
                title: `+ ${this.$t('static.products.syncVmp.title')}`,
                route: {
                  name: 'products.syncVmp',
                },
              },
            };
          }
        }
      }

      const productBundle = {
        title: this.$t('static.productBundles.filters.title'),
        options: [{
          title: this.$t('static.productBundles.filters.all'),
          route: {
            name: 'productBundles.index',
          },
        }],
        button: {
          title: `+ ${this.$t('static.productBundles.create.title')}`,
          route: {
            name: 'productBundles.create',
          },
        },
      };

      this.setInnerSidebar([
        productFilter,
        productBundle,
        vmpSyncMenu,
        {
          title: this.$t('static.productPackagings.filters.title'),
          options: [{
            title: this.$t('static.productPackagings.filters.all'),
            route: {
              name: 'productPackagings.index',
            },
          }],
          button: {
            title: `+ ${this.$t('static.productPackagings.create.title')}`,
            route: {
              name: 'productPackagings.create',
            },
          },
        },
        {
          title: this.$t('static.productGroups.filters.title'),
          options: [{
            title: this.$t('static.productGroups.filters.all'),
            route: {
              name: 'productGroups.index',
            },
          }],
          button: {
            title: `+ ${this.$t('static.productGroups.create.title')}`,
            route: {
              name: 'productGroups.create',
            },
          },
        },
        {
          title: this.$t('static.productTags.filters.title'),
          options: [{
            title: this.$t('static.productTags.filters.all'),
            route: {
              name: 'productTags.index',
            },
          }],
          button: {
            title: `+ ${this.$t('static.productTags.create.title')}`,
            route: {
              name: 'productTags.create',
            },
          },
        },
        // {
        //   title: this.$t('static.exciseEntry.title'),
        //   options: [{
        //     title: this.$t('static.exciseEntry.filters.all'),
        //     route: {
        //       name: 'exciseentry.index',
        //     },
        //   }],
        // },
      ]);
    },

    editProduct(product) {
      this.$router.push({
        name: 'productBundles.edit',
        params: { id: product.id },
      });
    },

    editProductNewTab(product) {
      const route = this.$router.resolve({
        name: 'productBundles.edit',
        params: { id: product.id },
      });
      window.open(route.href, '_blank');
    },
  },

  mounted() {
    this.sidebar();

    accountService.rememberPerPage('get', { from: 'product' })
    .then((data) => {
      this.limit = data.size;
      this.all(this.searchQuery.page, this.limit);
    }).catch((error) => {
      console.log(error);
    });
  },

  destroyed() {
    this.unsetInnerSidebar();
    store.dispatch('resetProducts');
  },

  mixins: [
    SearchMixin,
    stringFormatMixin,
  ],
};




// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/productBundles/index/index.js